import React, { useEffect, useState } from 'react';
import { Input } from './ui/Input';
import { Button } from './ui/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { addCar, updateCar } from '../store/carSlice';

export function CarForm({ editCarId, onDone }) {
  const dispatch = useDispatch();
  const existing = useSelector(state => state.cars.find(c => c.id === editCarId));

  const [formData, setFormData] = useState({
    make: '',
    model: '',
    year: '',
    plate: '',
    status: 'Active',
  });

  useEffect(() => {
    if (existing) {
      setFormData(existing);
    }
  }, [existing]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (existing) {
      dispatch(updateCar(formData));
    } else {
      dispatch(addCar({ ...formData, id: Date.now().toString() }));
    }
    onDone?.();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-xl">
      {['make', 'model', 'year', 'plate'].map(field => (
        <Input
          key={field}
          name={field}
          label={field.charAt(0).toUpperCase() + field.slice(1)}
          value={formData[field]}
          onChange={handleChange}
          required
        />
      ))}

      <div>
        <label className="block mb-1 font-medium text-[var(--text-secondary)]">Status</label>
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="w-full px-4 py-2 rounded border border-[var(--input-border)] bg-[var(--input-bg)] text-[var(--input-text)]"
        >
          <option>Active</option>
          <option>Inactive</option>
        </select>
      </div>

      <div className="flex gap-2">
        <Button type="submit">{existing ? 'Update' : 'Add'} Car</Button>
        <Button type="button" variant="outline" onClick={onDone}>Cancel</Button>
      </div>
    </form>
  );
}
